import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import PublicRoute from './routing/PublicRoute';
import PrivateRoute from './routing/PrivateRoute';
import React from 'react';
import { isAdyenDevice } from './utils/isAdyenDevice';

export const App = () => (
  <Router>
    <Routes>
      {!isAdyenDevice() && <Route path="/public/*" element={<PublicRoute />} />}
      <Route path="/*" element={<PrivateRoute />} />
    </Routes>
  </Router>
);

export default App;
